import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import * as actions from '../actions'

export const updateAdSetTemplateObservable = ([action, state]) => {
  const { brandId, adSetTemplateId } = action.payload
  const jwt = jwtSelector(state) || action.payload.jwt

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!brandId) {
    throw new Error('Brand ID Required')
  }
  if (!adSetTemplateId) {
    throw new Error('Ad Set Template ID required')
  }

  const settings = {
    method: 'PUT',
    contentType: 'application/json',
    responseType: 'json',
    headers: {
      'Authorization': jwt,
      'Content-Type': 'application/json',
    },
    url: `${Config.SERVICE_BASE}/facebookad/v1/adset_template/${adSetTemplateId}?brand_id=${brandId}`,
    body: JSON.stringify(action.payload.data),
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.UPDATE_AD_SET_TEMPLATE_FULFILLED,
        payload: payload.response,
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.UPDATE_AD_SET_TEMPLATE_REJECTED,
        payload: payload.response,
      })
    }),
  )
}

export const updateAdSetTemplateEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.UPDATE_AD_SET_TEMPLATE),
    withLatestFrom(state$),
    mergeMap(updateAdSetTemplateObservable),
    catchError((payload) => {
      return of({
        type: actions.UPDATE_AD_SET_TEMPLATE_REJECTED,
        payload,
      })
    }),
  )
}
